import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";
import { queryKeys } from "../api/queryKeys";
import { useAppContext } from "../../contexts/AppContext";
import OrderData from "../../types/OrderData";

export const useOrder = (enabled: boolean = true) => {
  const { getCampanhaSolarValue, setNrPedidoAtivo } = useAppContext();
  const isCampanhaSolar = getCampanhaSolarValue();

  return useQuery<OrderData, unknown, OrderData>({
    queryKey: queryKeys.order(isCampanhaSolar),
    queryFn: async () => {
      const response = await api.get<OrderData>(
        `orders?id_campanha_solar=${isCampanhaSolar}`
      );

      // Atualiza o número do pedido ativo no Context (que sincroniza com localStorage)
      if (response.data.nr_pedido) {
        setNrPedidoAtivo(String(response.data.nr_pedido));
      }

      return response.data;
    },
    enabled,
  });
};
